import type { FC } from 'react';
import React from 'react';

import type { TDefaultIcon } from './models';

export const DefaultIcon: FC<TDefaultIcon> = ({ Img, ShieldAlfaMIcon, iconSettings }) =>
    iconSettings ? (
        <Img alt={iconSettings.alt} height={32} src={iconSettings.src} width={32} />
    ) : (
        <ShieldAlfaMIcon color="#B8B9C0" height={32} width={32} />
    );
